import { render, staticRenderFns } from "./safetyHealthyTargetMonth.vue?vue&type=template&id=148e198c"
import script from "./safetyHealthyTargetMonth.vue?vue&type=script&lang=js"
export * from "./safetyHealthyTargetMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('148e198c')) {
      api.createRecord('148e198c', component.options)
    } else {
      api.reload('148e198c', component.options)
    }
    module.hot.accept("./safetyHealthyTargetMonth.vue?vue&type=template&id=148e198c", function () {
      api.rerender('148e198c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/sht/safetyHealthyTargetMonth.vue"
export default component.exports